import logo from './logo.svg';
import './App.css';

import Filter from './Filter';

function App() {
  return (
    <div className="App">
      <Filter/>
    </div>
  );
}

export default App;
